import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useAppConfig } from "../../../config/app-config";
import { Trademark } from "../../dataDisplay/Trademark";

export interface ColorSystemOption {
  value: string;
  label: string;
  trademark?: string;
  example?: string;
  disabled?: boolean;
  search?: string;
}

export interface ColorSystemSelectProps {
  onChange: (value: string) => void;
  value: string;
  options: Array<ColorSystemOption>;
  t: (key: string) => string;
}

export const ColorSystemSelect = ({
  onChange,
  value,
  options,
  t,
}: ColorSystemSelectProps) => {
  const [config] = useAppConfig();

  function isEnabled(option: ColorSystemOption) {
    return (
      option.value === "none" || config.colorSystems?.[option.value].enabled
    );
  }

  function isVisible(option: ColorSystemOption) {
    return (
      option.value === "none" || config.colorSystems?.[option.value].visible
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel>{t("filter_color_system_code")}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={t("filter_color_system_code")}
      >
        {options
          .filter((o) => isVisible(o))
          .map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={!isEnabled(option)}
            >
              <Stack
                width="100%"
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography noWrap sx={{ flexShrink: 0, maxWidth: "100%" }}>
                  {t(option.label)}
                  {option.trademark && (
                    <Trademark>{option.trademark}</Trademark>
                  )}
                </Typography>
                {Boolean(option.example) && (
                  <Typography
                    sx={{
                      marginLeft: 1,
                      minWidth: 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      paddingRight: "1px",
                    }}
                    color="text.secondary"
                    fontSize="var(--body-b3-12-regular-size, 12px)"
                    fontStyle="italic"
                  >
                    e.g., {option.example ? t(option.example) : ""}
                  </Typography>
                )}
              </Stack>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
